import { render, staticRenderFns } from "./recordsearch.vue?vue&type=template&id=055138ef&scoped=true&"
import script from "./recordsearch.vue?vue&type=script&lang=js&"
export * from "./recordsearch.vue?vue&type=script&lang=js&"
import style0 from "./recordsearch.vue?vue&type=style&index=0&id=055138ef&prod&lang=scss&"
import style1 from "./recordsearch.vue?vue&type=style&index=1&id=055138ef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055138ef",
  null
  
)

export default component.exports